import dayjs from 'dayjs';

enum TimeUnitEnum {
  DAYS = 'days',
  HOURS = 'hours',
}

const minutesToDays = (minutes: number) => {
  return dayjs.duration(minutes, 'minutes').asDays();
};

const minutesToHours = (minutes: number) => {
  return dayjs.duration(minutes, 'minutes').asHours();
};

const hoursToMinutes = (hours: number) => {
  return dayjs.duration(hours, 'hours').asMinutes();
};

const daysToMinutes = (days: number) => {
  return dayjs.duration(days, 'days').asMinutes();
};

export const convertMinutesToDaysAndHours = (minutes: number) => {
  const days = minutesToDays(minutes);

  if (Number.isInteger(days) && days >= 1) {
    return { timeUnit: TimeUnitEnum.DAYS, duration: days };
  }
  return { timeUnit: TimeUnitEnum.HOURS, duration: minutesToHours(minutes) };
};

export const convertDaysAndHoursToMinutes = (duration: number, timeUnit: 'days' | 'hours') => {
  if (!timeUnit) return;
  if (timeUnit === TimeUnitEnum.DAYS) {
    return daysToMinutes(duration);
  } else {
    return hoursToMinutes(duration);
  }
};

export const getMaximumLeadDurationError = (value: number, timeUnit: 'days' | 'hours') => {
  if (value === undefined || timeUnit === undefined) {
    return '';
  }
  if (timeUnit === TimeUnitEnum.DAYS && value > 365) {
    return '365 days is the maximum';
  }
  if (timeUnit === TimeUnitEnum.HOURS && value > 72) {
    return '72 hours is the maximum';
  }
  return '';
};
